import { Component, HostListener, OnInit, ViewEncapsulation } from '@angular/core';


import {Model,SurveyNG,Serializer,ComponentCollection } from "survey-angular";
import { setLicenseKey } from "survey-core";

import {  MenuItem, MessageService, SelectItem } from 'primeng/api';

import { ApiService } from 'src/app/_services/api.service';

import { GlobalService } from 'src/app/_services/global.service';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { SurveyCreatorModel } from 'survey-creator-core';
import { forkJoin } from 'rxjs';
import { Location } from '@angular/common'

@Component({
  selector: 'app-surveyviewcompilation',
  templateUrl: './surveyviewcompilation.component.html',
  styleUrls: ['./surveyviewcompilation.component.css'],
  providers: [ MessageService]
  
})
export class SurveyViewCompilationComponent implements OnInit {
  constructor(
    private apiService: ApiService,
    private messageService: MessageService,
    private globalService: GlobalService,
    private route: ActivatedRoute,
    private router: Router,
    private location: Location
  ) {
    setLicenseKey("Y2UyZmM4MzktN2Y3ZS00MGY3LWEwOGYtMzM1YjE3MTkwMzkwOzE9MjAyNC0wOC0wNw==" );
   }
 
  compilationName:string='';
  isLoading:boolean=true;

  struttureList:any[]=[];
  survey:any;
  selectedQuestionName:any;
  surveyInstance:any;
 
  creator:any;

  surveytitle='';
  action='';  
  jsonData:any;
  id:number;
  surveyCreatorModel: SurveyCreatorModel=new SurveyCreatorModel({});


  ngOnInit(): void {
    this.action=this.route.snapshot.paramMap.get('action');
    this.id=null;
    this.id=parseInt(this.route.snapshot.paramMap.get('id')); 
    let params= {compilation_id:this.id};
    this.apiService.get('surveys/surveyviewcompilation',params).subscribe(data => {
      let compilation=data.Result[0];
      this.apiService.get('dosurvey/rsalistall',{rsa_id:compilation['rsa_list_id']}).subscribe(datarsa => {
        for (const g of datarsa.Result) { 
            this.struttureList=[];
            g['rsalist'].forEach((r:any)=>{
              this.struttureList.push({
                value:r['code'],
                text:r['description']
              });
            });
     
        }
        this.compilationName=compilation.date_time_survey;
        this.jsonData = JSON.parse(compilation['json_result']);
        if (!Serializer.findClass("rsalist")) {
          ComponentCollection.Instance.add({
            //Unique component name. It becomes a new question type. Please note, it should be written in lowercase.
            name: "rsalist",
            //The text that shows on toolbox
            title: "Struttura",
            //The actual question that will do the job
            questionJSON: {
                type: "dropdown",
                placeholder: "Seleziona una struttura...",
                isRequired: true,
                choices:this.struttureList
              },
            });
        }

        let modello=JSON.parse(compilation['json_model']);
        /*
        modello.pages[0].elements.splice(0, 0,{
          type: "rsalist",
          name: "struttura",
          visible:true
        });
        */
        this.survey = new Model(modello);
        this.survey.mode = "display";
        this.survey.data =  JSON.parse(compilation['json_result']);
        this.isLoading=false;
        SurveyNG.render("surveyCreator", { model: this.survey });

      });
         
    });
  
      
  }
  
 

  addSingle(sev: string, sum: string, det: string) {
    this.messageService.add({severity: sev, summary: sum, detail: det});
  }

 
  
  public back() {
    this.location.back();
  }

}

var _this;